'use strict';
import getMainUrls from 'getUrls';
import getUrls from './getUrls';


module.exports = {
  'home': getUrls.getHomeUrl(),
  'my-profile': getUrls.getProfileUrl(),
  'logout': getMainUrls.getLogoutUrl(),
  'filters-and-notifications': getUrls.getFiltersAndNotificationsUrl(),
  'plan-columns-config': getUrls.getConfigurePlanUrl(),
};
